import type { GetWalksInPendingReviewResponse } from "wagAPI";
import type { GetWalksInPendingReviewParsedResponse } from "webApp";
export const getWalksInPendingReviewResponseParser = ({
  walk_ids: walkIds
}: GetWalksInPendingReviewResponse): GetWalksInPendingReviewParsedResponse => walkIds;
export default getWalksInPendingReviewResponseParser;